import React, { useEffect } from 'react';
import { GraphData, GraphPoint } from './FFTComparisonChart';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles(
  createStyles({
    tableStyle: {
      borderWidth: '1px',
      borderColor: '#000000',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    headerStyle: {
      borderWidth: '1px',
      borderColor: '#000000',
      borderStyle: 'solid',
      padding: '0px',
      textAlign: 'center',
    },
    tdStyle: {
      borderWidth: '1px',
      borderColor: '#000000',
      borderStyle: 'solid',
      padding: '2px',
    },
  })
);

export type FrequencyDataType = {
  frequency: number;
  value: number;
};

const getFrequencyData = (data: GraphData): GraphPoint[] => {
  type tmpType = {
    prev: GraphPoint;
    current: GraphPoint;
    next: GraphPoint;
  };
  var tmpList: tmpType[] = [];
  var pTempList: GraphPoint[] = [];

  //前、今、次の3点の組み合わせのコレクションを作成
  if (data !== undefined) {
    data.points.pop();
    var a = data.points;
    var b = data.points.slice(1);
    var c = data.points.slice(2);
    for (var i in c) {
      tmpList.push({ prev: a[i], current: b[i], next: c[i] });
    }

    const fill = tmpList.filter((v, index) => {
      return v.prev.yValue < v.current.yValue && v.next.yValue < v.current.yValue;
    });

    //カレントデータ取得

    for (var j in fill) {
      pTempList.push(fill[j].current);
    }

    //ソート降順
    pTempList.sort(function (a, b) {
      if (a.yValue > b.yValue) return -1;
      if (a.yValue < b.yValue) return 1;
      return 0;
    });

    // console.debug('==TEST==');
    // console.debug(`==fill==count ${fill.length} `);
    // console.debug(pTempList);
  }
  return pTempList;
};

type Props = {
  graphData: GraphData | undefined;
};

const FFTComparisonFrequency: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [frequencyDataList, setFrequencyDataList] = React.useState<FrequencyDataType[]>([]);

  useEffect(() => {
    var dt: FrequencyDataType[] = [];
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    setFrequencyDataList(dt);
  }, []);

  useEffect(() => {
    var dt: FrequencyDataType[] = [];
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });
    dt.push({ frequency: 0, value: 0 });

    if (props.graphData) {
      var points = getFrequencyData(props.graphData);
      for (let i = 0; i < dt.length; ++i) {
        if (points.length > i) {
          dt[i].frequency = points[i].xValue;
          dt[i].value = points[i].yValue;
        }
      }
    }
    setFrequencyDataList(dt);
  }, [props.graphData]);

  return (
    <Table className={classes.tableStyle}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.headerStyle}>No.</TableCell>
          <TableCell className={classes.headerStyle}>{t('FFTComparisonFrequency.周波数(Hz)', '周波数(Hz)')}</TableCell>
          <TableCell className={classes.headerStyle}>{t('FFTComparisonFrequency.値', '値')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {frequencyDataList?.map((row, index) => (
          <TableRow key={index}>
            <TableCell className={classes.tdStyle}>{index + 1}</TableCell>
            <TableCell className={classes.tdStyle}>{row.frequency === 0 ? '' : row.frequency.toFixed(1)}</TableCell>
            <TableCell className={classes.tdStyle} width={80}>
              {row.value === 0 ? '' : row.value.toExponential(3)}
            </TableCell>
          </TableRow>
        ))}
        <TableRow key={props.graphData != null ? props.graphData.lineNo : 'oaValue'}>
          <TableCell colSpan={3} className={classes.tdStyle}>
            {t('FFTComparisonFrequency.OA値', 'OA値：')}
            {props.graphData != null ? props.graphData.oaValue : ''}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default FFTComparisonFrequency;
